<template>
  <div class="card__reltopic">
    <h1 class="card__reltopic-title">
      Related Topics
      <slot name="default"></slot>
    </h1>
    <div class="card__reltopic-items">
      <ul v-if="topics.length" class="card__reltopic-list">
        <template v-for="topic in topics">
          <li :key="topic.id" @click="changeTopic(topic)">{{ topic.title }}</li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewReportsModalRelatedTopics',
  props: {
    topics: {
      type: Array,
      default: () => ([]),
    },
    contentId: {
      type: [String, Array],
      default: null,
    }
  },
  methods: {
    changeTopic(topic) {
      this.$emit("changeTopic", topic);
    }
  }
};
</script>

<style lang="scss" scoped>
.card__reltopic {
  background: #ffffff;
  box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  &-title {
    padding: 24px 28px;
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.1px;
    color: #234025;
    border-bottom: 1px solid #E3E5E1;
    @media (max-width: 960px) {
      padding: 24px 16px 16px;
      font-size: 15px;
    }
  }
  &-list {
    list-style: none;
    padding-left: 0;

    @media (max-width: 960px) {
      display: flex;
      padding: 24px 12px;
      flex-wrap: wrap;
    }
    li {
      font-size: 14px;
      font-weight: 700;
      line-height: 17px;
      letter-spacing: 0.1px;
      text-align: left;
      padding: 24px 28px;
      cursor: pointer;

      &:not(:last-child) {
        border-bottom: 1px solid #E3E5E1;
        @media (max-width: 960px) {
          border-bottom: 1px solid #029F48;
        }
      }

      @media (max-width: 960px) {
        padding: 4px 10px;
        font-size: 12px;
        color: var(--v-primary-base);
        border: 1px solid var(--v-primary-base);
        margin: 4px;
        border-radius: 2px;
      }
    }
  }
}
</style>
